import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const ArrowRightIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('ArrowRightIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m10.531 13.037 4.219-4.219m0 0L10.531 4.6m4.219 4.218H1.25"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
ArrowRightIcon.id = 'ArrowRightIcon';
ArrowRightIcon.displayName = 'ArrowRightIcon';
export default ArrowRightIcon;
